<div class="contains-button">
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div class="mt-2">
      <ng-container *ngFor="let item of socialItem">
        <div *ngIf="item.var != 'zalo' || device != 'desktop'" class="config-name mb-2">
          <p>{{item.name}}</p>
          <nz-switch [ngModel]="config.display[item.toggle]"
            (ngModelChange)="config.display[item.toggle] = $event; updateConfig()">
          </nz-switch>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate}} </span>
  </div>
  <!-- Cấu hình nâng cao -->
  <ng-container *ngIf="!isViewAll && configMode == 'advanced'" >
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- HIỂN THỊ MẠNG XÃ HỘI -->
      <li nz-submenu [nzTitle]="'hien_thi_mang_xa_hoi' | translate" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="px-2">
          <ng-container *ngFor="let item of socialItem">
            <div *ngIf="item.var != 'zalo' || device != 'desktop'" class="config-name mb-2">
              <p>{{item.name}}</p>
              <nz-switch [ngModel]="config.display[item.toggle]"
                (ngModelChange)="config.display[item.toggle] = $event; updateConfig()">
              </nz-switch>
            </div>
          </ng-container>
        </div>
      </li>

      <!-- CẤU HÌNH CHUNG -->
      <li nz-submenu [nzTitle]="'cau_hinh_chung' | translate" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <div class="d-flex justify-content-between align-items-center">
          <span class="title w-50">{{'mau_nen' | translate}}</span>
          <input class="input-color w-50" type="button" [cpOKButton]="true"
            [(colorPicker)]="class['sharing-social']['background-color']"
            [style.background]="class['sharing-social']['background-color']" (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
            [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
            [cpPresetLabel]="'bang_mau_mau' | translate"
            [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate" [cpPresetColors]="themeService.themeColors"
            (cpPresetColorsChange)="themeService.presetColorsChange($event)"
            (colorPickerOpen)="themeService.onPickerColorOpen($event)" />
        </div>
        <hr>
        <app-borders-config  [elementChoosing]="objectChoosing"  [device]="device" [class]="class"
          [borderClass]="class['sharing-social']" [id_object]="objectChoosing._id">
        </app-borders-config>
        <hr>
        <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
          [borderRadiusClass]="class['sharing-social']" [id_object]="objectChoosing._id">
        </app-borders-radius-config>
        <hr>
        <!-- Khoảng đệm -->
        <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
        [classPadding]="class['sharing-social']" [paddingConfigs]="[
          { type: 'top' },
          { type: 'bottom' },
          { type: 'left' },
          { type: 'right' }
        ]">
        </app-padding-config>
        <hr />
        <div>
          <div class="d-flex justify-content-between align-items-center">
            <p class="m-0 title">{{'khoang_cach_giua_cac_muc' | translate}}</p>
            <nz-input-number [nzMin]="0" [nzMax]="100" style="width: 40%"
              [ngModel]="class['sharing-social']?.gap | vhnumber"
              (nzBlur)="updateClass()"
              (ngModelChange)="class['sharing-social'].gap = $event + 'px'"
            ></nz-input-number>
          </div>
          <nz-slider [nzMin]="10" [nzMax]="100" 
            [ngModel]="class['sharing-social']?.gap | vhnumber"
            (nzOnAfterChange)="updateClass()" 
            (ngModelChange)="class['sharing-social'].gap = $event + 'px'">
          </nz-slider>
        </div>
      </li>

      <!-- CẤU HÌNH PHẦN TỬ -->
      <li nz-submenu [nzTitle]="'cau_hinh_phan_tu' | translate" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
        <div class="d-flex justify-content-between align-items-center">
          <span class="title w-50">{{'mau_nen' | translate}}</span>
          <input class="input-color w-50" type="button" [cpOKButton]="true"
            [(colorPicker)]="class['social-item']['background-color']"
            [style.background]="class['social-item']['background-color']" (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
            [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
            [cpPresetLabel]="'bang_mau_mau' | translate"
            [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate" [cpPresetColors]="themeService.themeColors"
            (cpPresetColorsChange)="themeService.presetColorsChange($event)"
            (colorPickerOpen)="themeService.onPickerColorOpen($event)" />
        </div>
        <div *ngIf="['column', 'column-reverse'].includes(class['sharing-social']['flex-direction'])" class="mt-2">
          <div class="d-flex justify-content-between align-items-center">
            <p class="m-0 title">{{'chieu_rong' | translate}}</p>
            <nz-input-number [nzMin]="10" [nzMax]="100" style="width: 40%"
              [ngModel]="class['social-item']?.width | vhnumber"
              (nzBlur)="updateClass()"
              (ngModelChange)="class['social-item'].width = $event + 'px'"
            ></nz-input-number>
          </div>
          <nz-slider [nzMin]="10" [nzMax]="100" 
            [ngModel]="class['social-item']?.width | vhnumber"
            (nzOnAfterChange)="updateClass()" 
            (ngModelChange)="class['social-item'].width = $event + 'px'">
          </nz-slider>
        </div>
        <div *ngIf="['row', 'row-reverse'].includes(class['sharing-social']['flex-direction'])" class="mt-2">
          <div class="d-flex justify-content-between align-items-center">
            <p class="m-0 title">{{'chieu_cao' | translate}}</p>
            <nz-input-number [nzMin]="10" [nzMax]="100" style="width: 40%"
              [ngModel]="class['social-item']?.height | vhnumber"
              (nzBlur)="updateClass()"
              (ngModelChange)="class['social-item'].height = $event + 'px'"
            ></nz-input-number>
          </div>
          <nz-slider [nzMin]="10" [nzMax]="100" 
            [ngModel]="class['social-item']?.height | vhnumber"
            (nzOnAfterChange)="updateClass()" 
            (ngModelChange)="class['social-item'].height = $event + 'px'">
          </nz-slider>
        </div>
        <hr>
        <app-borders-config  [elementChoosing]="objectChoosing"  [device]="device" [class]="class"
          [borderClass]="class['social-item']" [id_object]="objectChoosing._id">
        </app-borders-config>
        <hr>
        <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
          [borderRadiusClass]="class['social-item']" [id_object]="objectChoosing._id">
        </app-borders-radius-config>
      </li>

      <!-- ĐỊNH DẠNG CHỮ -->
      <li nz-submenu [nzTitle]="'dinh_dang_chu' | translate" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <p class="m-0">
            {{ ((config.text_enable ? 'an' : 'hien') + '_chu') | translate }}
          </p>
          <nz-switch [ngModel]="config.text_enable"
            (ngModelChange)="handleShowHideTextImage('text', $event)">
          </nz-switch>
        </div>
        <ng-container *ngIf="config.text_enable">
          <app-text-format-config [objectChoosing]="objectChoosing" [device]="device" [class]="class" [config]="config"
            [staticdata]="staticdata" [textContentClass]="class['social-item__content']" [textWrapperClass]="class['social-item']">
          </app-text-format-config>
          <!-- Khoảng cách chữ -->
          <app-letter-spacing-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
            [classLetterSpacing]="class['social-item__content']" (updateClass)="updateClass()">
          </app-letter-spacing-config>
          <!-- Khoảng cách dòng -->
          <app-line-height-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
            [classLineHeight]="class['social-item__content']" (updateClass)="updateClass()">
          </app-line-height-config>
        </ng-container>
      </li>

      <!-- BIỂU TƯỢNG -->
      <li nz-submenu [nzTitle]="'bieu_tuong' | translate" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <div class="d-flex justify-content-between align-items-center">
          <p class="m-0">
            {{ ((config.image_enable ? 't' : 'b') + 'at_bieu_tuong') | translate }}
          </p>
          <nz-switch [ngModel]="config.image_enable"
            (ngModelChange)="handleShowHideTextImage('image', $event)">
          </nz-switch>
        </div>
        <ng-container *ngIf="config.image_enable">
          <!-- CẤU HÌNH HÌNH ẢNH -->
          <ng-container>
            <div class="mt-2">
              <p class="m-0 title">{{'chon_de_cau_hinh' | translate}}</p>
              <nz-select [(ngModel)]="socialItemSelected">
                <ng-container *ngFor="let item of socialItem">
                  <nz-option *ngIf="config.display[item.toggle]"
                    [nzValue]="item.var" [nzLabel]="item.name">
                  </nz-option>
                </ng-container>
              </nz-select>
            </div>
            <div class="mt-2">
              <img [src]="staticdata.image?.[socialItemSelected]" alt="">
              <div class="field-row mt-2">
                <div class="mb-2">
                  <p class="m-0">{{'nguon_tai_anh' | translate}}</p>
                  <nz-select [(ngModel)]="image_source">
                    <nz-option nzValue="device" [nzLabel]="'tu_thiet_bi' | translate"></nz-option>
                    <nz-option nzValue="library" [nzLabel]="'tu_thu_vien' | translate"></nz-option>
                    <nz-option nzValue="url" [nzLabel]="'duong_dan_hinh_anh' | translate"></nz-option>
                    <nz-option nzValue="free_img" [nzLabel]="'kho_anh_dung_chung' | translate"></nz-option>
                  </nz-select>
                </div>
                <input type="file" (change)="onUpload($event)" id="uploadBackgroundImage" style="display: none;" />
                <div class="item mb-2">
                  <ng-container *ngIf="image_source == 'device'">
                    <!-- Kéo thả ảnh hoặc tải ảnh từ máy -->
                    <div class="drop-zone mb-2" [class.dragging]="dragging"
                    (drop)="onFileDropped_upload($event)" (dragover)="onDragOver_upload($event)" (dragleave)="onDragLeave_upload()">
                      <label *ngIf="!previewUploadUrl" for="uploadBackgroundImage">
                        <mat-icon>image</mat-icon>
                        <p>{{ 'keo_hinh_anh_vao_day_hoac' | translate }} <span>{{ 'tai_tep_len' | translate }}</span></p>
                      </label>
        
                      <div *ngIf="previewUploadUrl" class="preview">
                        <img [src]="previewUploadUrl" alt="Preview" />
                      </div>
        
                      <div *ngIf="previewUploadUrl" class="gr-btn button-list">
                        <button (click)="openUpload()">
                          <mat-icon>vertical_align_top</mat-icon>
                        </button>
                        <button (click)="previewUploadUrl = ''">
                          <mat-icon>close</mat-icon>
                        </button>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="image_source == 'library'">
                    <!-- Trường hợp tải ảnh từ thư viện -->
                    <button class="upload-background-image mb-2" (click)="openLibrary()">
                      <i class="bi bi-collection"></i> {{'chon_tu_thu_vien' | translate}}
                    </button>
                  </ng-container>
                  <ng-container *ngIf="image_source == 'url'">
                    <!-- Trường hợp chọn ảnh từ 1 đường dẫn bất kì -->
                    <textarea name="background-image" class="input w-100" id="background-image"
                      placeholder="{{'nhap_duong_dan_anh' | translate}}"
                      [(ngModel)]="staticdata.image[socialItemSelected]"
                      (blur)="updateStaticData()"
                      style="height: 80px;"></textarea>
                  </ng-container>
                  <ng-container *ngIf="image_source == 'free_img'">
                    <!-- Trường hợp tải ảnh từ thư viện -->
                    <button class="upload-background-image mb-2" (click)="openImageFree()">
                      <i class="bi bi-collection"></i> {{'kho_anh_dung_chung' | translate}}
                    </button>
                  </ng-container>
      
                  <!-- Hiển thị tên và đuôi file hình ảnh -->
                  <div *ngIf="staticdata.image[socialItemSelected].includes(id_subproject)"
                  class="my-1 img-info">
                    <p class="img-info__text">
                      {{ 'thu_muc_chua_tep_hinh_anh' | translate }}: 
                    </p>
                    <p class="img-info__text highlight ml-2">
                      {{ getFileInfo(staticdata.image[socialItemSelected]).folderPath }}
                    </p>
                    <p class="img-info__text mt-1">
                      {{ 'ten_tep_hinh_anh' | translate }}: 
                    </p>
                    <p class="img-info__text highlight ml-2">
                      {{ getFileInfo(staticdata.image[socialItemSelected]).fullFileName }}
                    </p>
                  </div>
      
                  <!-- Nút sao chép link hình ảnh -->
                  <button *ngIf="staticdata.image[socialItemSelected].includes(id_subproject)"
                  style="white-space: normal; border-color: #00a859;"
                  nz-button nzType="default" class="mt-2"
                  (click)="copyLinkImg(staticdata.image[socialItemSelected])">
                    {{ 'nhan_de_sao_chep_duong_dan_anh' | translate }}
                  </button>
      
                  <!-- Chuyển ảnh lên server -->
                  <button *ngIf="staticdata.image[socialItemSelected] && !staticdata.image[socialItemSelected].includes(id_subproject)"
                  style="width: 100%;" nz-button nzType="primary" class="mt-2" (click)="isShowPushImgToServerPopup = true">
                    {{'chuyen_anh_len_server' | translate}}
                  </button>
                </div>
              </div>
            </div>
          </ng-container>
          <hr />
          <div class="mt-2">
            <div class="d-flex justify-content-between align-items-center">
              <p class="m-0 title">{{'chieu_rong' | translate}}</p>
              <nz-input-number [nzMin]="10" [nzMax]="100" style="width: 40%"
                [ngModel]="class['social-item__content--image-wrapper']?.width | vhnumber"
                (nzBlur)="updateClass()"
                (ngModelChange)="class['social-item__content--image-wrapper'].width = $event + 'px'"
              ></nz-input-number>
            </div>
            <nz-slider [nzMin]="10" [nzMax]="100" 
              [ngModel]="class['social-item__content--image-wrapper']?.width | vhnumber"
              (nzOnAfterChange)="updateClass()" 
              (ngModelChange)="class['social-item__content--image-wrapper'].width = $event + 'px'">
            </nz-slider>
          </div>
          <div class="mt-2">
            <div class="d-flex justify-content-between align-items-center">
              <p class="m-0 title">{{'chieu_cao' | translate}}</p>
              <nz-input-number [nzMin]="10" [nzMax]="100" style="width: 40%"
                [ngModel]="class['social-item__content--image-wrapper']?.height | vhnumber"
                (nzBlur)="updateClass()"
                (ngModelChange)="class['social-item__content--image-wrapper'].height = $event + 'px'"
              ></nz-input-number>
            </div>
            <nz-slider [nzMin]="10" [nzMax]="100" 
              [ngModel]="class['social-item__content--image-wrapper']?.height | vhnumber"
              (nzOnAfterChange)="updateClass()" 
              (ngModelChange)="class['social-item__content--image-wrapper'].height = $event + 'px'">
            </nz-slider>
          </div>
          <ng-container *ngIf="config.text_enable">
            <div class="mt-2">
              <div class="d-flex justify-content-between align-items-center">
                <p class="m-0 title">{{'khoang_cach' | translate}}</p>
                <nz-input-number [nzMin]="0" [nzMax]="100" style="width: 40%"
                  [ngModel]="class['social-item']?.gap | vhnumber"
                  (nzBlur)="updateClass()"
                  (ngModelChange)="class['social-item'].gap = $event + 'px'"
                ></nz-input-number>
              </div>
              <nz-slider [nzMin]="0" [nzMax]="100" 
                [ngModel]="class['social-item']?.gap | vhnumber"
                (nzOnAfterChange)="updateClass()" 
                (ngModelChange)="class['social-item'].gap = $event + 'px'">
              </nz-slider>
            </div>
            <div class="mt-2">
              <p class="m-0 title">{{'thay_doi_vi_tri' | translate}}</p>
              <nz-radio-group [ngModel]="class['social-item']?.['flex-direction'] || 'row'"
                (ngModelChange)="class['social-item']['flex-direction'] = $event; updateConfig()">
                <label nz-radio nzValue="row">{{'chu_truoc_bieu_tuong_sau' | translate}}</label>
                <label nz-radio nzValue="row-reverse">{{'chu_sau_bieu_tuong_truoc' | translate}}</label>
                <label nz-radio nzValue="column-reverse">{{'bieu_tuong_nam_tren_chu' | translate}}</label>
                <label nz-radio nzValue="column">{{'bieu_tuong_nam_duoi_chu' | translate}}</label>
              </nz-radio-group>
            </div>
          </ng-container>
        </ng-container>
      </li>

      <!-- HIỆU ỨNG -->
      <li nz-submenu nzTitle="{{'hieu_ung'| translate}}" [(nzOpen)]="openMap.menu7"
        (nzOpenChange)="openHandler('menu7')">
        <app-choose-animations-config [elementChoosing]="objectChoosing"
          (openAnimationDetail)="openAnimationDetail($event)" [id_object]="objectChoosing._id" [device]="device"
          [class]="class" [config]="config" [staticdata]="staticdata" [cursorClass]="class['social-item']"
          [effect_hover]="effect_hover" [customize]="customize" [effectFileUsing]="'sharing-social'">
        </app-choose-animations-config>
      </li>

      <!-- HIỂN THỊ -->
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu3"
        (nzOpenChange)="openHandler('menu3')">
        <div class="editor-field">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
    </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình object -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 0">
      <app-animations-config [elementChoosing]="objectChoosing" [staticdata]="staticdata" [config]="config"
        [id_object]="objectChoosing._id" [customize]="customize" [device]="device">
      </app-animations-config>
    </div>
  </div>
</div>

<!-- Phần modal chuyển ảnh lên server -->
<nz-modal nzTitle="{{ 'chuyen_anh_len_server' | translate}}" [(nzVisible)]="isShowPushImgToServerPopup" [nzContent]="modalContent"
(nzOnCancel)="isShowPushImgToServerPopup = false;" (nzOnOk)="handleOkConfirm()" [nzFooter]="modalFooter">
  <ng-template #modalContent>
    <p>{{'nen_anh_tai_len' | translate}}</p>
    <nz-select style="margin-bottom: 15px" [ngModel]="compress_type" (ngModelChange)="compress_type = $event"
    nzPlaceHolder="{{'nen_anh_tai_len' | translate}}" nzAllowClear>
      <nz-option [nzValue]="'no-compress'" nzLabel="{{'khong_nen_anh_sau_khi_tai_len' | translate}}"></nz-option>
      <nz-option [nzValue]="'compress-screen'" nzLabel="{{'nen_anh_theo_ti_le_man_hinh_hien_thi' | translate}}"></nz-option>
      <nz-option [nzValue]="'compress-frame'" nzLabel="{{'nen_anh_theo_ti_le_khung_hien_thi_anh' | translate}}"></nz-option>
      <nz-option [nzValue]="'custom'" nzLabel="{{'nen_anh_theo_kich_thuoc_tu_chon' | translate}}"></nz-option>
    </nz-select>

    <mat-form-field *ngIf="compress_type == 'custom'" class="mr-4">
      <mat-label>{{'chieu_rong' | translate}}</mat-label>
      <input matInput placeholder="{{'chieu_rong' | translate}}" [(ngModel)]="compressWidth">
    </mat-form-field>

    <mat-form-field *ngIf="compress_type == 'custom'">
      <mat-label>{{'chieu_cao' | translate}}</mat-label>
      <input matInput placeholder="{{'chieu_cao' | translate}}" [(ngModel)]="compressHeight">
    </mat-form-field>
  </ng-template>
  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="isShowPushImgToServerPopup = false;">{{'khong' | translate}}</button>
    <button nz-button nzType="primary" (click)="handleOkConfirm()" [nzLoading]="isPushImgToServerLoading">{{'dong_y' | translate}}</button>
  </ng-template>
</nz-modal>